// extracted by mini-css-extract-plugin
export default {"page":"S0-z","cartModal":"T0-z","checkout":"U0-z","placeholder":"V0-z","account":"W0-z"};